export const PageTitle = ({ children }: { children: string }): React.ReactElement => {
  return (
    <h1 className="font-evogria font-normal text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-normal flex items-center tracking-[-0.25px] text-primary flex-none grow-0 uppercase">
      {children}
    </h1>
  )
}
